import _ from 'lodash';
import React from 'react';
import * as fields from './fields';

export default class FieldFactory
extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			config: {}
		};
	}

	componentDidMount () {
		const { fieldKey, formStore } = this.props;
		const config = formStore.get(fieldKey);

		this.setState({ config });
	}

	render () {
		const config = this.state.config;

		if (_.isEmpty(config)) {

			return null;
		}

		const fieldProps = { ...this.props };
		const FieldComponent = fields[config.type];

		return _.isFunction(FieldComponent) ?
			<FieldComponent { ...fieldProps } /> : null;
	}
}

export const addProps = (props) => {
	return (
		<FieldFactory { ...props } />
	);
}
